import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { currentMemberId: Number };

  connect() {
    this.highlightCurrentUser();
  }

  // Called when turbo stream updates the participants list
  participantsUpdated() {
    this.highlightCurrentUser();
  }

  highlightCurrentUser() {
    // Remove existing current user indicators
    this.element.querySelectorAll(".current-user").forEach((el) => el.remove());

    // Find and mark current user
    this.element.querySelectorAll(".participant").forEach((participant) => {
      const memberIdElement = participant.querySelector("[data-member-id]");
      if (
        memberIdElement &&
        parseInt(memberIdElement.dataset.memberId) === this.currentMemberIdValue
      ) {
        const indicator = document.createElement("span");
        indicator.className = "current-user";
        indicator.textContent = " (You)";
        participant.appendChild(indicator);
      }
    });
  }
}
